import { Button, Divider, Modal, Table, Typography } from '@components/ui';
import useLegacyProviderCode from '@hooks/query/software-provider/useLegacyProviderCode';
import { ReloadDoneOutlined } from '@icon';
import React from 'react';
import { useTheme } from 'styled-components';

const GenerateLegacyCode: React.FunctionComponent<{ canEdit?: boolean }> = (props) => {
  const theme = useTheme();
  const { close, modalProps, open } = Modal.useModal<string>();
  const { data, isLoading, refetch } = useLegacyProviderCode({
    enabled: false,
    refetchOnMount: false,
    cacheTime: 0,
    onSuccess: () => {
      open();
    },
  });

  return (
    <>
      <Table.Header
        title={
          (
            <>
              <Typography display="h5" as="span">
                Legacy párovací kód
              </Typography>
              <Typography style={{ color: theme.color.tint.secondary }} display="body2">
                Tu si môžete vygenerovať párovací kód pre spojenie s externou službou,
                <br />
                ktorá využíva
                <strong> napojenie na staršie API v1.</strong>
              </Typography>
            </>
          ) as any
        }
        extra={
          props.canEdit ? (
            <Button
              size="medium"
              onClick={() => refetch()}
              Icon={ReloadDoneOutlined}
              variant="ghost"
              loading={isLoading}
            >
              Generovať
            </Button>
          ) : null
        }
      />
      <Divider style={{ marginBottom: 16 }} />
      <Modal
        {...modalProps}
        title="Párovací kód"
        onClose={close}
        footer={
          <Modal.Actions
            actions={[{ key: 'close', variant: 'secondary', label: 'Zavrieť', onClick: close }]}
          />
        }
      >
        <Modal.Title>
          Kód:<b> {data?.code ?? '-'}</b>
        </Modal.Title>
        <Modal.Description>
          Teraz môžete použiť tento kód na spojenie s externou službou
        </Modal.Description>
      </Modal>
    </>
  );
};

export default React.memo(GenerateLegacyCode);
